import Modal from './modules/modal';
import Slider from './modules/flickity';
import Headerpin from './modules/headerpin';
import Cf7custom from './modules/cf7custom';
import ChartRules from './modules/chartrules';
import TabsController from './modules/TabsController';
import BurgerController from './modules/BurgerController';
import ParallaxController from './modules/ParallaxController';
import Stock from "./modules/Stock";


document.addEventListener("DOMContentLoaded", () => {

	/*
		MODALS
	*/
	new Modal({
        modalContClass: '.js-popup',
        modalTriggerClass: '.js-popup-trigger',
        modalCloseClass: '.js-popup-close',
        activeClass: '.active'
    });

	/*
		BURGER
	*/
    new BurgerController();
	
	/*
		SLIDERS
	*/
    new Slider('header');
    new Slider('advantages', {
    	on: {
			change: function( index ) {
				if(index < 9){
		            var i_ = '0' + (index+1);
		        } else {
		            var i_ = index+1;
		        }
		        document.querySelectorAll('.js-nums-item')[0].innerHTML = i_;
		        document.querySelectorAll('.advantages .line-item.active')[0].classList.remove('active');
		        document.querySelectorAll('.advantages .line-item')[index].classList.add('active');

				const imgBgs = document.querySelectorAll('.advantages-blockimg--item.used');
				if(imgBgs && imgBgs.length) {
					for(let el of imgBgs) {
						if(el) el.classList.remove('active');
					}

					imgBgs[index].classList.add('active');
				}

				const imgs = document.querySelectorAll('.advantages-blockimg--itemimg.used');
				if(imgs && imgs.length) {
					for(let el of imgs) {
						if(el) el.classList.remove('active');
					}

					imgs[index].classList.add('active');
				}
			}
		}
    });
    new Slider('reviews', {
    	on: {
			change: function( index ) {
				if(index < 9){
		            var i_ = '0' + (index+1);
		        } else {
		            var i_ = index+1;
		        }
		        document.querySelectorAll('.js-rev-item')[0].innerHTML = i_;
		        document.querySelectorAll('.reviews .line-item.active')[0].classList.remove('active');
		        document.querySelectorAll('.reviews .line-item')[index].classList.add('active');
			}
		}
    });
    new Slider('capabilities', {
    	on: {
			change: function( index ) {
				if(index < 9){
		            var i_ = '0' + (index+1);
		        } else {
		            var i_ = index+1;
		        }
		        document.querySelectorAll('.js-cap-item')[0].innerHTML = i_;
		        document.querySelectorAll('.capabilities .nav-line-item.active')[0].classList.remove('active');
		        document.querySelectorAll('.capabilities .nav-line-item')[index].classList.add('active');
			}
		}
    });

	/*
		AFFIX
	*/
	new Headerpin();
	
	/*
		CONTACT FORM 7
	*/
	new Cf7custom();
	
	/*
		CHART
	*/
	if(typeof chartData !== 'undefined') {
		new ChartRules(chartData);
	}

	/*
		TABS
	*/
	new TabsController({
        tabsCont: '.js-tabs-catalog-cont',
        tabLinks: '.js-tabs-catalog-btns button',
        tabPanels: '.js-tabs-catalog-panel'
    });

	/*
		DROPDOWNS
	*/
    if( document.querySelector(".drop-menu") ){
    	var drops = document.querySelectorAll(".drop-menu");
    	for(let d of drops){
            d.addEventListener('click', e => {
                d.querySelector('.drop-menu--drop').classList.toggle('active');
				
				const trigger = d.querySelector('.drop-menu--trigger');
				trigger.classList.toggle('active');

				const items = d.querySelectorAll('.drop-menu--item');
				for(let item of items){
					item.classList.remove('active');
					//active selected
					if(item.innerHTML == trigger.innerHTML) item.classList.add('active');
				}
            });
        }
    }

	 /*
        PARALLAX 
    */
   	new ParallaxController();

	/*
     STOCKS BLOCK
 	*/

	new Stock();
});